module.exports = __webpack_public_path__ + "media/src/LessonSchoolItemSearch/images/line_icon/menu-d2a87e86cf11d04ef5fa4720330f5f0e.svg";